/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Carsten Hibbeler
 * Date: 23.06.2016
 *
 */

import React, { useEffect } from 'external/react';
import PropTypes from 'external/prop-types';
import { Tab, Tabs } from 'external/react-bootstrap';
import { Header } from 'plugin/liferay-widgets-react-web';
import '../css/treelist.scss';
import '../css/layer-chooser.scss';
import { LayerChooser } from './LayerChooser';

const LayerChooserSidebar = ({ layerDescriptions, onClose, onLayersChange, context, activeLayerUuids, reEvaluate }) => {

    useEffect(() => {
        // force update after mount to render situationmap sidebar
        // TODO combine layer chooser and situationmap plugin(?)
        reEvaluate && reEvaluate();
    }, []);

    return (
        <div className="layer-chooser">
            <Header onClose={ onClose }>
                <h3 className="m-0 leaflet-sidebar__title">Themen & Lagekarten</h3>
            </Header>

            <div className="layer-chooser__content">
                <Tabs defaultActiveKey="layers">
                    <Tab eventKey="layers" title="Themen">
                        <div className="py-2">
                            <LayerChooser
                                layerDescriptions={ layerDescriptions }
                                onLayersChange={ onLayersChange }
                                mapId={ context.contextId }
                                activeLayerUuids={ activeLayerUuids }
                            />
                        </div>
                    </Tab>
                    <Tab eventKey="situationmaps" title="Lagekarten">
                        <div id={ 'situation-map-chooser-container' + context.contextId } className="py-2"/>
                    </Tab>
                </Tabs>
            </div>

        </div>
    );
};

LayerChooserSidebar.propTypes = {
    layerDescriptions: PropTypes.array,
    context: PropTypes.object,
    activeLayerUuids: PropTypes.object,
    onClose: PropTypes.func,
    onLayersChange: PropTypes.func,
    reEvaluate: PropTypes.func,
};

export default LayerChooserSidebar;



// WEBPACK FOOTER //
// ./js/components/LayerChooserSidebar.jsx